import { filter } from 'lodash'
import { combineReducers } from 'redux'
import { loadingReducer } from 'redux-foundry'
import { API_LISTAR_CLASSES_OCUPACAO,
  API_CRIAR_CLASSES_OCUPACAO,
  API_EXCLUIR_CLASSES_OCUPACAO,
  API_ATUALIZAR_CLASSES_OCUPACAO } from 'store/modules/api/classesOcupacao.actions'

const lista = (state = [], { type, payload }) => {
  switch (type) {
    case API_LISTAR_CLASSES_OCUPACAO.success:
      return payload.sort((a, b) => a.subCategoria.localeCompare(b.subCategoria))
    case API_CRIAR_CLASSES_OCUPACAO.success:
      return [...state, payload].sort((a, b) => a.subCategoria.localeCompare(b.subCategoria))
    case API_ATUALIZAR_CLASSES_OCUPACAO.success:
      return state.map((e) => (e.id === payload.id ?
        payload : e))
    case API_EXCLUIR_CLASSES_OCUPACAO.success:
      return filter(state, (o) => o.id !== Number(payload))
    default: return state
  }
}

const isCarregandoLista = loadingReducer(false, API_LISTAR_CLASSES_OCUPACAO)

const isSaving = loadingReducer(false, API_CRIAR_CLASSES_OCUPACAO)
const isUpdate = loadingReducer(false, API_ATUALIZAR_CLASSES_OCUPACAO)

export default combineReducers({
  lista,
  isCarregandoLista,
  isSaving,
  isUpdate,
})
